import { Modal, NewButton, NewButtonVariant, SelectInput } from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { arrayOf, func, number, shape, string } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import classes from "./ArchiveStatusReassignModal.module.scss";

const ArchiveStatusReassignModal = ({
  usageCount,
  targetNoun,
  itemNoun,
  replacementOptions,
  onConfirmReassign,
}) => {
  const dispatch = useDispatch();
  const [replacementId, setReplacementId] = useState("");

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.ARCHIVE_STATUS_REASSIGN_MODAL));
  };

  const onClickConfirm = () => {
    onDismiss();
    onConfirmReassign(Number.parseInt(replacementId, 10));
  };

  const options = replacementOptions.map((option) => ({
    value: option.id,
    label: option.name,
  }));

  return (
    <Modal data-testid="archive-status-reassign-modal" show onDismiss={onDismiss} backdrop centered>
      <Modal.Header>Delete {targetNoun}</Modal.Header>

      <Modal.Body className={classes.body}>
        <p>
          This status is aligned to {usageCount} archived {itemNoun}. You need to pick a new
          status to align to these {itemNoun} before you are able to delete this status.
        </p>
        <div className={classes.field}>
          <label className={classes.field__label} htmlFor="archive_status_reassign_select">
            Replacement status *
          </label>
          <div>
            <SelectInput
              optionListClassName={classes.select_options}
              value={replacementId || ""}
              options={options}
              placeholder="Select a replacement status"
              id="archive_status_reassign_select"
              onChange={(value) => setReplacementId(value)}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={onDismiss}>
          Cancel
        </NewButton>
        <NewButton
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
          disabled={!replacementId}
        >
          Confirm
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

ArchiveStatusReassignModal.propTypes = {
  usageCount: number.isRequired,
  targetNoun: string.isRequired,
  itemNoun: string.isRequired,
  replacementOptions: arrayOf(shape({ id: number, name: string })).isRequired,
  onConfirmReassign: func.isRequired,
};

export default ArchiveStatusReassignModal;
